import { useOrganization, useUser } from '@clerk/clerk-react';
import { useEffect } from 'react';

import { configuration } from '@/constants/config';

const DashboardAskAimei = () => {
  const { organization } = useOrganization();
  const { user } = useUser();

  useEffect(() => {
    if (!user) return;

    // Create and load the Voiceflow widget script
    const script = document.createElement('script');
    script.onload = function () {
      window?.voiceflow?.chat?.load?.({
        verify: { projectID: configuration.VOICEFLOW_PROJECT_ID },
        url: 'https://general-runtime.voiceflow.com',
        // The agent runtime rejects alias values ("production"/"development");
        // only pass explicit 24-hex version IDs.
        versionID: /^[0-9a-f]{24}$/.test(configuration.VOICEFLOW_VERSION_ID)
          ? configuration.VOICEFLOW_VERSION_ID
          : undefined,
        userID: user?.id || 'unknown',
        launch: {
          event: {
            type: 'launch',
            payload: {
              userId: user?.id || 'unknown',
              zorId: organization?.id || 'unknown',
              org_id: organization?.id || 'unknown',
              org_name: organization?.name || 'unknown',
            },
          },
        },
        render: {
          mode: 'embedded',
          target: document.getElementById('voiceflow-chat') as HTMLElement,
        },
        user: {
          name: user?.firstName + ' ' + user?.lastName,
          image: user?.imageUrl || '',
        },
        voice: {
          url: 'https://runtime-api.voiceflow.com',
        },
      });
    };
    script.src = 'https://cdn.voiceflow.com/widget-next/bundle.mjs';
    script.type = 'text/javascript';

    // Find the first script tag and insert our script before it
    const firstScript = document.getElementsByTagName('script')[0];
    if (firstScript && firstScript.parentNode) {
      firstScript.parentNode.insertBefore(script, firstScript);
    }

    // Cleanup function to remove the script when component unmounts
    return () => {
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, [user, organization]);

  return (
    <div className="fixed inset-0 h-screen w-screen min-[920px]:left-[230px] min-[920px]:w-[calc(100vw-230px)]">
      <div id="voiceflow-chat" className="h-full w-full pt-16" />
    </div>
  );
};

// Extend Window interface for TypeScript
declare global {
  interface Window {
    voiceflow?: {
      chat?: {
        load?: (options: {
          verify?: { projectID: string };
          url?: string;
          versionID?: string;
          userID?: string;
          launch?: {
            event: {
              type: string;
              payload: Record<string, string>;
            };
          };
          voice?: {
            url: string;
          };
          render?: {
            mode: string;
            target: HTMLElement;
          };
          user?: {
            name: string;
            image: string;
          };
          assistant?: {
            stylesheet: string;
          };
        }) => void;
        open?: () => void;
        close?: () => void;
        toggle?: () => void;
        interact?: (message: { type: string; payload: string }) => void;
      };
    };
  }
}

export { DashboardAskAimei };
